export default "__VITE_PUBLIC_ASSET__ee969dbe__"